import React, { useEffect, useState } from 'react';
import { FaFileAlt } from 'react-icons/fa';
import { MdExpandLess, MdExpandMore, MdDashboard } from 'react-icons/md';
import { useHistory } from 'react-router';

import { Roles } from '@dinnisoft/esteio-gestao-common';
import { Collapse, Divider, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { CadastroAnimalIcon, CadastroLotesIcon } from 'assets/icons/Icons';
import { useAuth } from 'contexts/auth';
import { AppLogo } from 'styles/Styles';
import { DrawerNavigatorProps, MenuProps } from 'types/drawer';
import { getLogo, getSlugFromURL } from 'utils/whiteLabel';

import { DrawerToolbar } from './styles';

const DrawerNavigator: React.FC<DrawerNavigatorProps> = ({ title }: DrawerNavigatorProps) => {
  const history = useHistory();
  // const [componentsOpen, setComponentsOpen] = useState(false);
  const [cadastrosOpen, setCadastrosOpen] = useState(false);
  const context = useAuth();
  const PROJECT = getSlugFromURL();

  const cadastrosChildren = [
    { name: 'Animais', path: '/animais', icon: <CadastroAnimalIcon size={20} /> },
    { name: 'Lotes', path: '/lotes', icon: <CadastroLotesIcon size={20} /> },
  ];

  const centralChildren = [...cadastrosChildren];

  const childrenByRole: Record<string, any[]> = {
    [Roles.central]: [...centralChildren],
  };

  const basicMenu: MenuProps[] = [
    { name: 'Tela Inicial', path: '/', icon: <MdDashboard size={24} /> },
  ];

  if (
    Object.keys(childrenByRole).includes(context.selectedRole.toString()) &&
    childrenByRole[context.selectedRole] &&
    childrenByRole[context.selectedRole].length > 0 &&
    Object.keys(context.selectedFazenda).length > 0
  ) {
    basicMenu.push({
      name: 'Cadastros',
      icon: <FaFileAlt size={20} />,
      var: cadastrosOpen,
      set: setCadastrosOpen,
      children: childrenByRole[context.selectedRole],
      path: '',
    });
  }

  useEffect(() => {
    const menuCadastros = basicMenu.find((item) => item.name === 'Cadastros');
    setCadastrosOpen(menuCadastros?.children?.some((e) => e.name === title) ?? false);
  }, [title]);

  return (
    <div>
      <DrawerToolbar>
        <AppLogo
          src={getLogo(context.selectedProject ?? PROJECT)}
          height="150"
          width="135"
          alt="logo"
        />
      </DrawerToolbar>
      <Divider />
      <List>
        {basicMenu.map((item, index) => (
          <div key={index}>
            <ListItemButton
              onClick={() => (item.set ? item.set(!item.var) : history.push(item.path))}
              selected={title === item.name}
              sx={{
                color: '#b8c7ce',
                '&:hover': {
                  bgcolor: '#1e282c',
                  '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                    color: '#fff',
                  },
                },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit' }}>{item.icon}</ListItemIcon>
              <ListItemText sx={{ color: 'inherit' }} primary={item.name} />
              {item.set ? item.var ? <MdExpandLess /> : <MdExpandMore /> : null}
            </ListItemButton>
            {item.children &&
              item.children.map((child, i) => (
                <Collapse in={item.var} key={i}>
                  <List component="div" disablePadding>
                    <ListItemButton
                      sx={{
                        pl: 4,
                        color: '#b8c7ce',
                        '&:hover': {
                          bgcolor: '#1e282c',
                          '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                            color: '#fff',
                          },
                        },
                      }}
                      onClick={() => history.push(child.path)}
                      selected={title === child.name}
                    >
                      <ListItemIcon sx={{ color: 'inherit' }}>{child.icon}</ListItemIcon>
                      <ListItemText primary={child.name} sx={{ color: 'inherit' }} />
                    </ListItemButton>
                  </List>
                </Collapse>
              ))}
          </div>
        ))}
      </List>
    </div>
  );
};

export default DrawerNavigator;
